import { apiClient } from './client';

import type { AxiosRequestConfig } from 'axios';

/**
 * Orval mutator every generated operation calls through. Passes the config straight
 * through so React Query's QueryFunctionContext.signal aborts the HTTP request on
 * cancellation. Returns `response.data`, not the envelope: generated hooks expect the
 * payload, and rejections are normalized to AppError by the interceptor chain.
 */
export const apiMutator = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response = await apiClient.request<T>({ ...config, ...options });
  return response.data;
};

export default apiMutator;
